import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const DashboardPage = lazy(() => import('@/pages/dashboard/ui/DashboardPage'))

export const Route = createFileRoute('/_protected/dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Suspense fallback={<Loader />}>
      <DashboardPage />
    </Suspense>
  )
}
